/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { PriceChangeswithProductDataViewProductCurrentPrice } from './priceChangeswithProductDataViewProductCurrentPrice';
import { PriceChangeswithProductDataViewProductTaxRate } from './priceChangeswithProductDataViewProductTaxRate';
import { StockDiscrepancyDetailListViewFactorCalculationsFactorContainer } from './stockDiscrepancyDetailListViewFactorCalculationsFactorContainer';
import { SupplierInventoryCodesWithDetailsViewSupplier } from './supplierInventoryCodesWithDetailsViewSupplier';

export interface PriceChangeswithProductDataViewProduct { 
    /**
     * The unique identifier of this record.
     */
    productId?: number;
    fullName?: string;
    shortName?: string;
    /**
     * A reference to the primary key in the Containers Table.
     */
    containerId?: number;
    /**
     * A reference to the primary key in the PluGroups Table.
     */
    pluGroupId?: number;
    /**
     * A reference to the primary key in the Ranges Table.
     */
    rangeId?: number;
    lastCost?: number;
    averageCost?: number;
    container?: StockDiscrepancyDetailListViewFactorCalculationsFactorContainer;
    productGroup?: SupplierInventoryCodesWithDetailsViewSupplier;
    taxRate?: PriceChangeswithProductDataViewProductTaxRate;
    productRange?: SupplierInventoryCodesWithDetailsViewSupplier;
    currentPrice?: PriceChangeswithProductDataViewProductCurrentPrice;
}